<template>
  <div class="help-home-wrapper flex flex-col bg-white">
    <Head>
      <Title>{{ $messages("help.meta.title") }}</Title>
      <Meta name="description" hid="description" :content="$messages('help.meta.description')" />
    </Head>

    <HelpHero
      :breadcrumbs="[
        {
          title: $messages('label.home'),
          to: $mRouter.getLocalRoute({ name: 'index' }),
        },
        {
          title: $messages('page_labels.help'),
        },
      ]"
      :headline="$messages('help.help_hero.headline')"
      :title="$messages('help.help_hero.title')"
    />
    <HelpTheHelpSearch />
    <HelpArticleList
      :title="$messages('help.popular_topics')"
      :articles="popularArticles"
    />
    <HelpCategoryList :categories="categories" />
    <HelpVideoList />
    <HelpTheHelpContact />
  </div>
</template>
<script setup>
import { COUNTRY_COOKIE_KEY } from '@/utils/constants'
const helpApi = useHelp()

definePageMeta({
  layout: 'default'
})
const locale = useLocale()
const countryCookie = useCookie(COUNTRY_COOKIE_KEY).value

const promisesResponse = await Promise.all([
  helpApi.getHelpPopularArticles(locale, countryCookie),
  helpApi.getHelpCategories(locale,countryCookie)
])

const popularArticles = promisesResponse[0]
const categories = promisesResponse[1]

</script>
